module.exports = __webpack_public_path__ + "static/media/heat.8076e9ff.svg";